import { Box, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { resolve } from 'path-browserify';
import React from 'react'
import { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';
import readXlsFile from 'read-excel-file';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

class Sorteos extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            archivo: '',
            sorteo: [],
            consultaSorteo: false,
        }
        this.manejarCambiosDatosArchivo = this.manejarCambiosDatosArchivo.bind(this);
        this.manejarEnvioArchivo = this.manejarEnvioArchivo.bind(this);
    }
    render(){
        return (
            <>
                <Container>
                    <h3>Sorteo</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <Box sx={{ flexGrow: 1}} >
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={2}>

                            </Grid>
                            <Grid item xs={2.5}>
                                <Item>Cargar Excel</Item>
                            </Grid>
                            <Grid item xs={2}>
                                <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                            </Grid>
                            <Grid item xs={2}>
                                <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                            </Grid>
                        </Grid>
                    </Box>
                    {this.state.consultaSorteo
                    ?
                        <Container>
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.sorteo.map((name, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{name.dato1}</StyledTableCell>
                                                <StyledTableCell>{name.dato2}</StyledTableCell>
                                                <StyledTableCell>{name.dato3}</StyledTableCell>
                                                <StyledTableCell>{name.dato4}</StyledTableCell>
                                                <StyledTableCell>{name.dato5}</StyledTableCell>
                                                <StyledTableCell>{name.dato6}</StyledTableCell>
                                                <StyledTableCell>{name.dato7}</StyledTableCell>
                                                <StyledTableCell>{name.dato8}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        null
                    }
                    <br/>
                </Container>
            </>
        )
    }

    manejarCambiosDatosArchivo(e){
        e.preventDefault();
        let valor = e.target.files[0];
        readXlsFile(valor).then((rows) => {
            this.setState({
                archivo: rows,
                prueba: rows[1],
            })
        });
    }

    async manejarEnvioArchivo(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.archivo]);

        const control = await fetch(`${Constantes.RUTA_API}/realizar_sorteo.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
        });
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Total de personas sorteadas: ' + res[1],
                sorteo: res[2],
                consultaSorteo: true,
            });
        }
    }
}

export default Sorteos